import {
  ANONYMOUS_LOCALE_STORAGE_KEY,
  AppLocale,
  DEFAULT_LOCALE,
  isSupportedLocale,
} from './config';
import { ResolvedLocale } from './types';

const getStoredAnonymousLocale = (): string | null => {
  try {
    return typeof window === 'undefined'
      ? null
      : window.localStorage.getItem(ANONYMOUS_LOCALE_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setStoredAnonymousLocale = (locale: AppLocale): void => {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(ANONYMOUS_LOCALE_STORAGE_KEY, locale);
    }
  } catch {
    // localStorage can be unavailable or restricted; memory fallback is enough.
  }
};

export const resolveAnonymousLocale = (search?: string): ResolvedLocale => {
  let queryLocale: string | null = null;

  try {
    const currentSearch = search ?? (typeof window === 'undefined' ? '' : window.location.search);
    queryLocale = new URLSearchParams(currentSearch).get('locale');
  } catch {
    queryLocale = null;
  }

  if (isSupportedLocale(queryLocale)) {
    setStoredAnonymousLocale(queryLocale);
    return { locale: queryLocale, source: 'query' };
  }

  const storedLocale = getStoredAnonymousLocale();
  if (isSupportedLocale(storedLocale)) {
    return { locale: storedLocale, source: 'storage' };
  }

  return { locale: DEFAULT_LOCALE, source: 'default' };
};

export const resolveAuthenticatedLocale = (userLocale: unknown): AppLocale => {
  if (isSupportedLocale(userLocale)) {
    setStoredAnonymousLocale(userLocale);
    return userLocale;
  }

  const storedLocale = getStoredAnonymousLocale();
  return isSupportedLocale(storedLocale) ? storedLocale : DEFAULT_LOCALE;
};
